import { Navigate } from 'react-router-dom'
import { useAdminAuthStore } from '../store/adminAuthStore'

export function AdminProtectedRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAdminAuthStore((s) => s.isAuthenticated)
  if (!isAuthenticated) return <Navigate to="/admin/login" replace />
  return <>{children}</>
}
